<template>
    <div class="file-input-wrapper">
        <form enctype="multipart/form-data" novalidate>
            <div class="drag-area" :class="isOver ? ' hover-draganddrop' : ''">
                <input 
                    ref="inputFile"
                    type="file" 
                    class="input-file" 
                    :accept="accepted"
                    @change="fileCb"
                    :disabled="disabled"
                />
                <div class="desc">
                    <div v-if="!file">
                        {{ $t('initial-state-fileuploader') }}
                    </div>
                    <div v-else>
                        {{ `${$t('arquivo')}: ${file.name}` }}
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: {
        accepted: {
            type: String,
            default: ''
        },
        value: {
            type: [String, File],
            default: ''
        },
        allowedtypes: {
            type: Array,
            default: []
        },
        disabled: {
            type: Boolean,
            default: false
        },
        /* Retornar o arquivo por classe File ao invés do seu B64 */
        returnRawFile: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            reader: null,
            file: null,
            isOver: false
        };
    },
    created () {
        this.initReader();
    },
    mounted(){
        this.$refs.inputFile.addEventListener("dragover", () => {
            this.isOver = true; // add class on drag over
        });
        this.$refs.inputFile.addEventListener("dragleave", () => {
            this.isOver= false; // remove class on drag leave
        }); 
    },
    methods: {
        showMessage (type, message) {
            let data = {
                type: type,
                message: message
            };

            this.$emit('alert', data);
        },
        fileCb (e) {
            if (!e.target.files.length) return;
            
            let file = e.target.files[0];

            if (file.size > 2097152) {
                console.error(`Arquivo ${file.name} rejeitado por tamanho: ${file.size}.`)
                this.showMessage('error', 'msg-erro-import-tamanho');
                this.clearFile();
                return;
            }

            if (file.size == 0) {
                console.error(`Arquivo ${file.name} rejeitado por tamanho: ${file.size}.`)
                this.showMessage('error', 'msg-erro-import-sem-dados');
                this.clearFile();
                return;
            }

            if (this.allowedtypes.length > 0 && !this.allowedtypes.includes(file.type)) {
                console.error(`Arquivo ${file.name} rejeitado por tipo${file.type ? `: ${file.type}` : ''}. Tipos permitidos: ${this.allowedtypes.join(', ')}.`)
                this.showMessage('error', 'msg-erro-import-tipo');
                this.clearFile();
                return;
            }
            
            this.file = file;

            console.log(`Arquivo: [${this.file.name}] tipo [${this.file.type}], tamanho ${this.file.size} bytes.`);

            if (this.returnRawFile) {
                this.$emit('input', file);
            } else {
                this.reader.readAsDataURL(this.file);
            }
        },
        fileRead () {
            console.log('Arquivo lido com sucesso.');
            this.$emit('input', this.reader.result);
        },
        fileError () {
            console.log('Erro ao ler arquivo.', this.reader.error);
            this.clearFile();
            this.showMessage('error', 'msg-erro-import-arquivo');
        },
        clearFile () {
            this.file = null;
            this.initReader();
            this.$refs.inputFile.value = '';
        },
        initReader() {
            this.reader = new FileReader();
            this.reader.onload = this.fileRead;
            this.reader.onerror = this.fileError;
        }
    }
}
</script>

<style lang="scss" scoped>
.file-input-wrapper {
    display: flex;
    justify-content: center;

    form{
        width: 100%;

        .hover-draganddrop {
            background: $primary-color-hover;
            outline: 2px dashed $bg-color;
            color: $bg-color;
        }
    }

    .drag-area {
        width: 100%;
        height: 100%;
        background: $darker-bg-color;
        outline: 2px dashed $table-border;
        outline-offset: -10px;
        border-radius: 3px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;

        &:hover {
            background: $primary-color-hover;
            outline: 2px dashed $bg-color;
            color: $bg-color;
        }

        .input-file {
            width: 100%;
            height: 100%;
            opacity: 0;
            z-index: 10;
            cursor: pointer;
        }

        .desc {
            width: 100%;
            padding: 10px;
            position: absolute;
            z-index: 0;

            div {
                text-align: center;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

}

</style>